export default __webpack_public_path__ + "static/media/tail-bone.454217f5.svg";